module.exports = __webpack_public_path__ + "static/img/pageBg.bf7386a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/pageBg.webp
// module id = /h49
// module chunks = 0